export const JP_TRANSLATION = {
  messages: {
    saveDataSuccessfully: '保存が完了しました」',
    generalErrorMsg: 'インターネットに接続されていないため保存できません。'
  },
  adminStatus: {
    Active: '有効',
    Inactive: '無効',
    Pool: '保留中'
  },
  adminRoles: {
    SuperAdmin: 'スーパー管理者',
    StoreAdmin: '店舗一覧',
    StoreManagerAdmin: '店舗管理者一覧',
    StoreCustomerAdmin: 'ユーザー管理',
    AdministratorAdmin: 'GMTS管理者一覧',
    ArticleAdmin: '記事管理',
    VideoSubmissionAdmin: 'CM動画入稿',
    VideoApprovalAdmin: 'CM動画承認',
    SalesAdmin: '売上管理',
    GoLiveRewardAdmin: 'Go Liver報酬管理',
    VideoManager: '動画管理'
  },
  errorMessages: {
    CannotAssignSuperAdmin: 'スーパー管理者を変更できません'
  },
  validationMessages: {
    passwordPolicy: 'パスワードには最低8文字、少なくとも1文字、1つの数字、1つの特殊文字が必要です',
    confirmPasswordNotMatched: 'パスワードを再入力してください。'
  },
  videoGoLiver: {
    statusWaiting: '承認待ち',
    statusApproved: '承認済み',
    statusRejected: '却下',
    InappropriateContent: '不適切な内容が含まれている',
    PersonNotReflected: '映ったはいけない人物が映っている',
    InappropriateRemarks: '不適切な発言が含まれている',
    0: ''
  },
  customerQuestion: {
    AboutLogin: 'ログインについて',
    AboutStoreInformation: '店舗情報について',
    AboutSupportVideo: '応援動画について',
    Others: 'その他'
  },
  deposit: {
    STORE: '店舗',
    HQ: '本部'
  },
  userProfile: {
    title: '管理者情報',
    userName: 'ユーザー名',
    email: 'メールアドレス',
    fullName: 'フルネーム',
    changePassword: 'パスワードを変更',
    changePasswordSave: '変更',
    changePasswordCancel: '閉じる',
    confirmPasswordPlaceholder: '新しいパスワードと同じパスワードを入力してください。',
    oldPassword: '現在のパスワード',
    newPassword: '新しいパスワード',
    confirmPassword: '新しいパスワード（確認用）',
    passwordPolicy: 'パスワードは、大文字、小文字、数字を含む8~12文字で設定お願いします。記号は@$!%*#?&を利用可能です。',
    passwordRequired: 'パスワードが必須です。',
    confirmPasswordRequired: 'パスワード確認が必須です。',
    confirmPasswordNotMatched: 'パスワードを再入力してください。',
    resetPasswordSuccessfully: 'パスワードが正常にリセットされました'
  }
}
